module.exports = __webpack_public_path__ + "static/media/ic_notification.e39b13b3.svg";